import React from 'react';

// Official WhatsApp glyph, rendered in white so it sits on the brand-black FAB.
const WhatsAppGlyph = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.46 1.712 6.4L3.2 28.8l6.56-1.716a12.74 12.74 0 0 0 6.243 1.62h.005c7.06 0 12.8-5.74 12.8-12.8 0-3.42-1.332-6.635-3.75-9.053A12.72 12.72 0 0 0 16.004 3.2Zm0 23.02h-.004a10.6 10.6 0 0 1-5.4-1.48l-.388-.23-4.03 1.056 1.075-3.926-.253-.403a10.57 10.57 0 0 1-1.62-5.637c0-5.867 4.774-10.64 10.646-10.64 2.843 0 5.514 1.108 7.524 3.12a10.57 10.57 0 0 1 3.117 7.526c0 5.867-4.774 10.64-10.643 10.64Zm5.836-7.968c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.573-1.588-.95-.848-1.592-1.895-1.779-2.215-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.624-.523-.54-.72-.55l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.669 0 1.574 1.146 3.096 1.306 3.309.16.213 2.253 3.44 5.46 4.824.763.33 1.36.527 1.824.674.766.244 1.464.21 2.016.127.615-.092 1.892-.773 2.158-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373Z"/>
  </svg>
);

const WhatsAppButton = () => {
  const phone = '443333357733';
  const message = encodeURIComponent("Hello Obsidian Chauffeurs, I'd like to enquire about a booking.");
  const href = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="group fixed bottom-6 right-6 z-[60] flex items-center"
    >
      <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-300 ease-out group-hover:max-w-[200px] group-hover:opacity-100 group-hover:mr-3 rounded-full bg-black/90 backdrop-blur px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-white shadow-lg">
        Message&nbsp;us
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-black text-white shadow-[0_8px_30px_rgba(0,0,0,0.35)] ring-1 ring-white/10 transition-transform duration-300 group-hover:scale-105 group-active:scale-95">
        <span className="absolute inset-0 rounded-full bg-black animate-ping opacity-20 group-hover:opacity-0" />
        <WhatsAppGlyph className="relative h-7 w-7" />
      </span>
    </a>
  );
};

export default WhatsAppButton;
